import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { FieldSelect } from "@conserveit/blocks";
import SiteSelect from "./SiteSelect";

const ProjectOptions = (options) =>
  Object.keys(options).map((key) => {
    const option = {
      label: options[key],
      value: key,
    };
    return option;
  });

const SiteGroupForm = ({ project, onChange, projectOptions }) => {
  const [projectSites, setProjectSites] = useState(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (project) {
      setLoading(true);
      axios.get(`/project/${project}/sites`).then(({ data }) => {
        setProjectSites(data);
        setLoading(false);
      });
    }
  }, [project]);

  return (
    <Fragment>
      <FieldSelect
        className="project"
        label="Project"
        name="project"
        value={{ label: project, value: project }}
        placeholder="Select Project.."
        onChange={({ value }) => onChange(value, "project")}
        options={ProjectOptions(projectOptions)}
        menuPosition="fixed"
      />

      {!loading && projectSites && (
        <SiteSelect
          options={projectSites}
          name="group_name"
          label="Group Name"
          onChange={onChange}
        />
      )}
    </Fragment>
  );
};

export default SiteGroupForm;
